<div class="row">
  <div class="col">
    <span *ngIf="showEditButton">
      <a title="Edit" *ngIf="!editWithModal" class="mx-1"
        (click)="navigateToEdit(displayValue.data.editRoutePath,displayValue.data.id)"
        [ngClass]="{ disabled: !canEdit && !isLocked }">
        <img src="../../../assets/Krid/img/edit-icon.svg" alt /></a>
      <a title="Edit" *ngIf="editWithModal" class="mx-1"
        (click)="onActionClick('edit', displayValue.data.id, displayValue)" [ngClass]="{ disabled: !canEdit && !isLocked  }">
        <img src="../../../assets/Krid/img/edit-icon.svg" alt />
      </a>
    </span>
    <a title="Delete" class="mx-1" (click)="onActionClick('delete', displayValue.data.id, '')" *ngIf="showDeleteButton"
      [ngClass]="{ disabled: !canDelete && !isLocked  }">
      <img src="../../../assets/Krid/img/delete-icon.svg" alt />
    </a>
    <a title="View" class="mx-1" (click)="onActionClick('view', displayValue.data.id, '')" *ngIf="showViewButton"
      [ngClass]="{ disabled: !canView  && isLocked}">
      <img src="../../../assets/Krid/img/view-btn-icon.svg" alt />
    </a>
    <a title="Add Row" class="mx-1" (click)="onActionClick('add', displayValue.data.id, '')"
      *ngIf="displayValue.showAddButton">
      <img src="../../../assets/Krid/img/view-btn-icon.svg" alt="Add Row" />
    </a>
    <a title="Remove Row" class="mx-1" (click)="onActionClick('remove', displayValue.data.id, '')"
      *ngIf="displayValue.showRemoveButton">
      <img src="../../../assets/Krid/img/delete-icon.svg" alt="Remove Row" />
    </a>
    <!-- <a title="Edit Role" class="mx-1" (click)="onActionClick('editRole', displayValue.data.id, '')" *ngIf="showEditRole"
      [ngClass]="{ disabled: !canEdit && !isLocked  }">
      <img src="../../../assets/Krid/img/role-icon.svg" alt />
    </a> -->
  </div>
</div>  